import React from 'react';
import Button from '../../common/Button';

const WarningAlert = ({text, onCloseClick}) => {
    return (
        <div className="configuration-editor-warning-alert">
            <div>
                {__(text)}

                <div className='configuration-editor-snapshot-alert-buttons'>
                    <Button theme={Button.Theme.BorderOnly} color={Button.Color.White}
                            onClick={onCloseClick}>{__('OK')}</Button>
                </div>
            </div>
        </div>
    )
}

export default WarningAlert;